import SelectableSearchableSortableListCtrl from '../../dashboard/manage/SelectableSearchableSortableListCtrl';

import laborCostUsersUrl from './laborCostUsers.html';

class LaborCostUsersCtrl extends SelectableSearchableSortableListCtrl {
  constructor(
    Authentication,
    AlertService,
    PersonaCollection,
    Restangular,
    Utils,
    UserUtils,
    TabsControl,
    filterFilter,
    toDateMediumFilter,
    $rootScope,
    $scope,
    $parse,
    $document
  ) {
    'ngInject';

    super(filterFilter, $parse, 'searchValue', (invalidateFn) => {
      $scope.$on('$destroy', PersonaCollection.onChange(invalidateFn));
    });

    Object.assign(this, {
      Authentication,
      AlertService,
      PersonaCollection,
      Restangular,
      Utils,
      UserUtils,
      TabsControl,
      filterFilter,
      toDateMediumFilter,
      $rootScope,
      $scope,
      $parse,
      $document,
    });
  }

  $onInit() {
    this['sortMethod-regularUsers'] = 'normalizedDisplayName';
    this['sortMethod-deactivatedUsers'] = 'normalizedDisplayName';
    this.userGroups = ['regularUsers', 'deactivatedUsers'];
    this.cancelCounter = 0;
    this.saveCounter = 0;
    this.refreshCounter = 0;
    this.wagesToSave = {};
    this.today = this.Utils.getNowDate();

    this._refreshList();
    this.$document.on('keypress', this.enterClickListener);
    const personaCollectionListener = this.PersonaCollection.onChange(() => this._refreshList());
    this.$scope.$on('$destroy', () => {
      personaCollectionListener();
      this.$document.off('keypress', this.enterClickListener);
    });
  }

  getManageTableRowSize(user) {
    const isExpanded = {
      positions: user.$$positionsExpanded,
      locations: user.$$locationsExpanded,
    };

    return this.UserUtils.getManageTableRowSize(user, isExpanded);
  }

  enterClickListener = (event) => {
    if (event.which === 13 && event.shiftKey === false && this.laborCostUsersForm.$dirty) {
      this.submitWageEditing();
      event.preventDefault();
    }
  };

  _refreshList() {
    this.users = this._getManagableUsers();
    if (!this.Authentication.user.isAdmin) {
      this.users = this.users.filter((user) => !user.isManager || user.isMe);
    }
    this.deactivatedUsers = this.users.filter((u) => !u.active);
    this.regularUsers = this.users.filter((u) => u.active);
    this.refreshCounter++;
  }

  _getManagableUsers() {
    return this.PersonaCollection.allUsers.filter((user) => this.UserUtils.canManageUser(user));
  }

  cancelWageEditing() {
    this.laborCostUsersForm.$setPristine();
    this.cancelCounter++;
    this.wagesToSave = {};
  }

  async submitWageEditing() {
    if (this.laborCostUsersForm.$invalid) {
      this.laborCostUsersForm.$setSubmitted();
      throw 'Form invalid';
    }

    this.laborCostUsersForm.$setPristine();
    this.saveCounter++;

    const userIds = Object.keys(this.wagesToSave);
    if (!userIds.length) {
      return false;
    }

    const promises = userIds.reduce((acc, userId) => {
      const userWages = this.wagesToSave[userId];
      const wages = Object.keys(userWages).map((positionId) => {
        if (userWages[positionId].regularRate === '') {
          userWages[positionId].deleted = true;
          userWages[positionId].regularRate = 0;
        }
        return userWages[positionId];
      });

      return [...acc, this.Restangular.all('labor/wages/user/bulk').customPUT(wages)];
    }, []);

    if (promises.length) {
      await Promise.all(promises);
      this.displaySuccessMessage(promises.length);
      this.wagesToSave = {};
    }
  }

  displaySuccessMessage(count) {
    if (count > 1) {
      this.AlertService.success(
        'Wages updated. You can modify the dates from when they are effective under Options'
      );
    } else {
      this.AlertService.success(
        'Wage updated. You can modify the date from when it is effective under Options'
      );
    }
  }

  canEditWages(user) {
    const { id, isAdmin, isManager } = this.Authentication.user;
    return isAdmin || (isManager && id !== user.id);
  }
}

export default {
  controller: LaborCostUsersCtrl,
  controllerAs: 'ctrl',
  templateUrl: laborCostUsersUrl,
  bindings: {
    search: '=',
  },
};
